import { Navigate, Outlet } from 'react-router';

import { useUser } from '@/components/auth-provider';
import { useRole } from '@/hooks/use-role';

export function PublicRoute() {
  const { user } = useUser();
  const { isEmployee } = useRole();

  if (user) {
    const homeRoute = isEmployee ? '/schedule' : '/jobs';
    return <Navigate to={user.onboarded ? homeRoute : '/onboarding'} replace />;
  }

  return <Outlet />;
}
